import React from "react";
import PlaceholderContainer from "./PlaceholderContainer";
import { Placeholder, PlaceholderLine, PlaceholderMedia } from 'placeholders/Placeholder'

const PlaceholderUserCard = ({ containerStyle = {} } ) => {
	
	return (
		<PlaceholderContainer style={ containerStyle }>
			<Placeholder
				Left={PlaceholderMedia}>
				
				<PlaceholderLine />
				<PlaceholderLine width={80} />
			</Placeholder>
		</PlaceholderContainer>
	)
}

export default PlaceholderUserCard
